function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; var r = _regenerator(), e = r.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor; function n(r) { var e = "function" == typeof r && r.constructor; return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name)); } var o = { "throw": 1, "return": 2, "break": 3, "continue": 3 }; function a(r) { var e, t; return function (n) { e || (e = { stop: function stop() { return t(n.a, 2); }, "catch": function _catch() { return n.v; }, abrupt: function abrupt(r, e) { return t(n.a, o[r], e); }, delegateYield: function delegateYield(r, o, a) { return e.resultName = o, t(n.d, _regeneratorValues(r), a); }, finish: function finish(r) { return t(n.f, r); } }, t = function t(r, _t, o) { n.p = e.prev, n.n = e.next; try { return r(_t, o); } finally { e.next = n.n; } }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n; try { return r.call(this, e); } finally { n.p = e.prev, n.n = e.next; } }; } return (_regeneratorRuntime = function _regeneratorRuntime() { return { wrap: function wrap(e, t, n, o) { return r.w(a(e), t, n, o && o.reverse()); }, isGeneratorFunction: n, mark: r.m, awrap: function awrap(r, e) { return new _OverloadYield(r, e); }, AsyncIterator: _regeneratorAsyncIterator, async: function async(r, e, t, o, u) { return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u); }, keys: _regeneratorKeys, values: _regeneratorValues }; })(); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regeneratorAsync(n, e, r, t, o) { var a = _regeneratorAsyncGen(n, e, r, t, o); return a.next().then(function (n) { return n.done ? n.value : a.next(); }); }
function _regeneratorAsyncGen(r, e, t, o, n) { return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise); }
function _regeneratorAsyncIterator(t, e) { function n(r, o, i, f) { try { var c = t[r](o), u = c.value; return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) { n("next", t, i, f); }, function (t) { n("throw", t, i, f); }) : e.resolve(u).then(function (t) { c.value = t, i(c); }, function (t) { return n("throw", t, i, f); }); } catch (t) { f(t); } } var r; this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () { return this; })), _regeneratorDefine2(this, "_invoke", function (t, o, i) { function f() { return new e(function (e, r) { n(t, i, e, r); }); } return r = r ? r.then(f, f) : f(); }, !0); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  "class": "list-unstyled m-0 font-size-12 main-menu"
};
var _hoisted_2 = {
  key: 0
};
var _hoisted_3 = {
  "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": ""
};
var _hoisted_4 = {
  key: 1
};
var _hoisted_5 = {
  "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": ""
};
var _hoisted_6 = {
  key: 2
};
var _hoisted_7 = {
  "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": ""
};
var _hoisted_8 = {
  "class": ""
};
var _hoisted_9 = {
  "class": "p-2 font-size-12 font-weight-semibold d-block text-decoration-none sh-text-dark-blue link-hover-dark-blue btn-back",
  role: "button"
};
var _hoisted_10 = {
  "class": "list-unstyled m-0 font-size-12 main-submenu"
};
var _hoisted_11 = {
  key: 0
};
var _hoisted_12 = {
  key: 1
};
var _hoisted_13 = {
  "class": ""
};
var _hoisted_14 = {
  "class": "p-2 font-size-12 font-weight-semibold d-block text-decoration-none sh-text-dark-blue link-hover-dark-blue btn-back",
  role: "button"
};
var _hoisted_15 = {
  "class": "list-unstyled m-0 font-size-12 main-submenu"
};
var _hoisted_16 = {
  key: 0
};
var _hoisted_17 = {
  key: 1
};
var _hoisted_18 = {
  "class": ""
};
var _hoisted_19 = {
  "class": "p-2 font-size-12 font-weight-semibold d-block text-decoration-none sh-text-dark-blue link-hover-dark-blue btn-back",
  role: "button"
};
var _hoisted_20 = {
  "class": "list-unstyled m-0 font-size-12 main-submenu"
};
var _hoisted_21 = {
  key: 0
};
var _hoisted_22 = {
  key: 1
};
var _hoisted_23 = {
  "class": "position-absolute top-0 end-0 m-2 p-2 btn-group dropup d-md-none d-block"
};
var _hoisted_24 = {
  "class": "btn-template position-relative"
};
var _hoisted_25 = {
  "class": "m-2"
};
var _hoisted_26 = {
  "class": "message-template pt-2"
};
var _hoisted_27 = {
  "class": "list-unstyled m-0 font-size-14 main-menu mt-3"
};
var _hoisted_28 = {
  key: 0
};
var _hoisted_29 = {
  "class": "py-2 d-block text-decoration-none sh-text-dark-blue mt-1",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": ""
};
var _hoisted_30 = {
  key: 1
};
var _hoisted_31 = {
  "class": "py-2 d-block text-decoration-none sh-text-dark-blue mt-1",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": ""
};
var _hoisted_32 = {
  key: 2
};
var _hoisted_33 = {
  "class": "py-2 d-block text-decoration-none sh-text-dark-blue mt-1",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": ""
};
var _hoisted_34 = {
  "class": ""
};
var _hoisted_35 = {
  "class": "d-block text-decoration-none btn-back",
  role: "button"
};
var _hoisted_36 = {
  "class": "list-unstyled m-0 font-size-14 main-submenu mt-2"
};
var _hoisted_37 = {
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_38 = {
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_39 = {
  key: 0,
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_40 = {
  key: 1,
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_41 = {
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_42 = {
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_43 = {
  "class": ""
};
var _hoisted_44 = {
  "class": "d-block text-decoration-none btn-back",
  role: "button"
};
var _hoisted_45 = {
  "class": "list-unstyled m-0 font-size-12 main-submenu"
};
var _hoisted_46 = {
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_47 = {
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_48 = {
  key: 0
};
var _hoisted_49 = {
  key: 1,
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_50 = {
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_51 = {
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_52 = {
  "class": ""
};
var _hoisted_53 = {
  "class": "d-block text-decoration-none btn-back",
  role: "button"
};
var _hoisted_54 = {
  "class": "list-unstyled m-0 font-size-12 main-submenu"
};
var _hoisted_55 = {
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_56 = {
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_57 = {
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_58 = {
  key: 0,
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_59 = {
  key: 1,
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_60 = {
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_61 = {
  "class": "d-flex justify-content-between align-items-center"
};
import { ref, reactive } from 'vue';
import { useVModels } from '@vueuse/core';
import { useUserStore } from '@dashboardApp/stores/UserStore';
import { getTemplateGroup, getTemplateMeta, replaceMetaVars, getTemplateTrackingTitle } from '@dashboardApp/helpers/inboxTemplates';
import { useModal } from 'bootstrap-vue-next';
import { performAnalyticsTracking } from '@dashboardApp/helpers/performAnalyticsTracking';
export default {
  __name: 'MessageTemplates',
  props: {
    content: String,
    subject: String,
    template: String,
    validateTemplate: Boolean,
    selectedContent: String,
    contactName: String,
    types: Array,
    isMobile: {
      type: Boolean,
      "default": false
    },
    hasAttachedProducts: {
      type: Boolean,
      "default": false
    }
  },
  emits: ['update:content', 'update:subject', 'update:template', 'update:validateTemplate', 'update:selectedContent', 'dropdownShown'],
  setup: function setup(__props, _ref) {
    var _userStore$user$count;
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var userStore = useUserStore();
    var _useVModels = useVModels(props, emit),
      content = _useVModels.content,
      subject = _useVModels.subject,
      template = _useVModels.template,
      validateTemplate = _useVModels.validateTemplate,
      selectedContent = _useVModels.selectedContent;
    var showOptions = ref(false);
    var showMainMenu = ref(true);
    var ddOptions = ref(null);
    var isMobileRef = ref(props.isMobile);
    var modal = useModal();
    var hideMessageTemplate = function hideMessageTemplate(trigger) {
      return modal.hide(trigger, 'messageTemplate');
    };
    var _performAnalyticsTrac = performAnalyticsTracking(),
      trackEvent = _performAnalyticsTrac.track;
    function onSubMenuShow() {
      showMainMenu.value = false;
    }
    function onSubMenuHide() {
      showMainMenu.value = true;
    }
    var varReplacements = {
      'country': (_userStore$user$count = userStore.user.country) === null || _userStore$user$count === void 0 ? void 0 : _userStore$user$count.country
    };
    function fillMeta(_x) {
      return _fillMeta.apply(this, arguments);
    }
    function _fillMeta() {
      _fillMeta = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(key) {
        var _ddOptions$value;
        var meta;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              varReplacements.name = props.contactName;
              _context.next = 3;
              return getTemplateMeta(getTemplateGroup(userStore.user.id), key);
            case 3:
              meta = _context.sent;
              content.value = selectedContent.value = replaceMetaVars(meta.content, varReplacements);
              subject.value = replaceMetaVars(meta.subject, varReplacements);
              ;
              template.value = key;
              (_ddOptions$value = ddOptions.value) === null || _ddOptions$value === void 0 || _ddOptions$value.toggle();
              hideMessageTemplate(); // For mobile view

              trackEvent('directoryClickMessageTemplate', {
                Template: getTemplateTrackingTitle(key)
              });
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _fillMeta.apply(this, arguments);
    }
    return function (_ctx, _cache) {
      var _component_BCollapse = _resolveComponent("BCollapse");
      var _component_BDropdownText = _resolveComponent("BDropdownText");
      var _component_BDropdown = _resolveComponent("BDropdown");
      var _component_BModal = _resolveComponent("BModal");
      var _directive_b_toggle = _resolveDirective("b-toggle");
      var _directive_b_modal = _resolveDirective("b-modal");
      return _openBlock(), _createElementBlock(_Fragment, null, [!isMobileRef.value ? (_openBlock(), _createBlock(_component_BDropdown, {
        key: 0,
        onShown: _cache[19] || (_cache[19] = function ($event) {
          return _ctx.$emit('dropdownShown');
        }),
        ref_key: "ddOptions",
        ref: ddOptions,
        modelValue: showOptions.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = function ($event) {
          return showOptions.value = $event;
        }),
        variant: "link",
        "menu-class": "message-template border-0 p-2",
        "toggle-class": "btn-template position-relative",
        "no-caret": "",
        "auto-close": "outside",
        offset: "0,10",
        placement: "top-end",
        "class": "position-absolute top-0 end-0 m-2 p-2 btn-group dropup d-md-block d-none"
      }, {
        "button-content": _withCtx(function () {
          return _cache[41] || (_cache[41] = [_createElementVNode("span", {
            "class": "badge rounded-pill text-bg-primary position-absolute top-50 end-0 translate-middle-y font-weight-regular"
          }, "Message templates", -1)]);
        }),
        "default": _withCtx(function () {
          return [_createVNode(_component_BDropdownText, null, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass(["position-relative collapse toggle-menu", {
                  show: showMainMenu.value
                }])
              }, [_cache[45] || (_cache[45] = _createElementVNode("div", {
                "class": "p-2 letter-spacing-10 font-size-11 font-weight-semibold opacity-75 text-uppercase"
              }, "Message Templates", -1)), _createElementVNode("ul", _hoisted_1, [props.types.includes('Dropshippers') ? (_openBlock(), _createElementBlock("li", _hoisted_2, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_3, _cache[42] || (_cache[42] = [_createTextVNode("Dropshipping")]))), [[_directive_b_toggle, void 0, void 0, {
                "dropship-menu": true
              }]])])) : _createCommentVNode("", true), props.types.includes('Wholesalers') || props.types.includes('Liquidators') ? (_openBlock(), _createElementBlock("li", _hoisted_4, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, _cache[43] || (_cache[43] = [_createTextVNode("Wholesale")]))), [[_directive_b_toggle, void 0, void 0, {
                "wholesale-menu": true
              }]])])) : _createCommentVNode("", true), props.types.includes('Manufacturers') ? (_openBlock(), _createElementBlock("li", _hoisted_6, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_7, _cache[44] || (_cache[44] = [_createTextVNode("Manufacturers")]))), [[_directive_b_toggle, void 0, void 0, {
                "manufacturer-menu": true
              }]])])) : _createCommentVNode("", true)])], 2), _createVNode(_component_BCollapse, {
                "class": "position-relative",
                id: "dropship-menu",
                onShow: onSubMenuShow,
                onHide: onSubMenuHide
              }, {
                "default": _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_8, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_9, _cache[46] || (_cache[46] = [_createTextVNode("Dropshipping")]))), [[_directive_b_toggle, void 0, void 0, {
                    "dropship-menu": true
                  }]]), _createElementVNode("ul", _hoisted_10, [_createElementVNode("li", null, [_createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = function ($event) {
                      fillMeta('dropshipper-generalenquiry');
                      validateTemplate.value = true;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "General inquiry")]), _createElementVNode("li", null, [_createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = function ($event) {
                      fillMeta('dropshipper-bestselling');
                      validateTemplate.value = true;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "Best selling products")]), __props.hasAttachedProducts ? (_openBlock(), _createElementBlock("li", _hoisted_11, [_createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = function ($event) {
                      fillMeta('dropshipper-pricerequest');
                      validateTemplate.value = false;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "Pricing request")])) : _createCommentVNode("", true), __props.hasAttachedProducts ? (_openBlock(), _createElementBlock("li", _hoisted_12, [_createElementVNode("a", {
                    onClick: _cache[3] || (_cache[3] = function ($event) {
                      fillMeta('dropshipper-productstock');
                      validateTemplate.value = false;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "Product stock")])) : _createCommentVNode("", true), _createElementVNode("li", null, [_createElementVNode("a", {
                    onClick: _cache[4] || (_cache[4] = function ($event) {
                      fillMeta('dropshipper-shippercosts');
                      validateTemplate.value = false;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "Shipping costs and times")]), _createElementVNode("li", null, [_createElementVNode("a", {
                    onClick: _cache[5] || (_cache[5] = function ($event) {
                      fillMeta('dropshipper-ebayamazon');
                      validateTemplate.value = true;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "Dropshipping on eBay/Amazon")])])])];
                }, undefined, true),
                _: 1
              }), _createVNode(_component_BCollapse, {
                "class": "position-relative",
                id: "wholesale-menu",
                onShow: onSubMenuShow,
                onHide: onSubMenuHide
              }, {
                "default": _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_13, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_14, _cache[47] || (_cache[47] = [_createTextVNode("Wholesale")]))), [[_directive_b_toggle, void 0, void 0, {
                    "wholesale-menu": true
                  }]]), _createElementVNode("ul", _hoisted_15, [_createElementVNode("li", null, [_createElementVNode("a", {
                    onClick: _cache[6] || (_cache[6] = function ($event) {
                      fillMeta('wholesalers-generalinquiry');
                      validateTemplate.value = true;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "General inquiry")]), _createElementVNode("li", null, [_createElementVNode("a", {
                    onClick: _cache[7] || (_cache[7] = function ($event) {
                      fillMeta('wholesalers-bestproducts');
                      validateTemplate.value = true;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "Best selling products")]), __props.hasAttachedProducts ? (_openBlock(), _createElementBlock("li", _hoisted_16, [_createElementVNode("a", {
                    onClick: _cache[8] || (_cache[8] = function ($event) {
                      fillMeta('wholesalers-pricerequest');
                      validateTemplate.value = false;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "Pricing request")])) : _createCommentVNode("", true), __props.hasAttachedProducts ? (_openBlock(), _createElementBlock("li", _hoisted_17, [_createElementVNode("a", {
                    onClick: _cache[9] || (_cache[9] = function ($event) {
                      fillMeta('wholesalers-productstock');
                      validateTemplate.value = false;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "Product stock")])) : _createCommentVNode("", true), _createElementVNode("li", null, [_createElementVNode("a", {
                    onClick: _cache[10] || (_cache[10] = function ($event) {
                      fillMeta('wholesalers-shippingcosts');
                      validateTemplate.value = false;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "Shipping costs")]), _createElementVNode("li", null, [_createElementVNode("a", {
                    onClick: _cache[11] || (_cache[11] = function ($event) {
                      fillMeta('wholesalers-ebayamazon');
                      validateTemplate.value = true;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "Selling on eBay/Amazon")])])])];
                }, undefined, true),
                _: 1
              }), _createVNode(_component_BCollapse, {
                "class": "collapse position-relative",
                id: "manufacturer-menu",
                onShow: onSubMenuShow,
                onHide: onSubMenuHide
              }, {
                "default": _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_18, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_19, _cache[48] || (_cache[48] = [_createTextVNode("Manufacturers")]))), [[_directive_b_toggle, void 0, void 0, {
                    "manufacturer-menu": true
                  }]]), _createElementVNode("ul", _hoisted_20, [_createElementVNode("li", null, [_createElementVNode("a", {
                    onClick: _cache[12] || (_cache[12] = function ($event) {
                      fillMeta('manufacturers-leadtimes');
                      validateTemplate.value = true;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "Lead Times")]), _createElementVNode("li", null, [_createElementVNode("a", {
                    onClick: _cache[13] || (_cache[13] = function ($event) {
                      fillMeta('manufacturers-generalinquiry');
                      validateTemplate.value = true;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "General inquiry")]), _createElementVNode("li", null, [_createElementVNode("a", {
                    onClick: _cache[14] || (_cache[14] = function ($event) {
                      fillMeta('manufacturers-bestproducts');
                      validateTemplate.value = true;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "Best selling products")]), __props.hasAttachedProducts ? (_openBlock(), _createElementBlock("li", _hoisted_21, [_createElementVNode("a", {
                    onClick: _cache[15] || (_cache[15] = function ($event) {
                      fillMeta('manufacturers-pricerequest');
                      validateTemplate.value = false;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "Pricing request")])) : _createCommentVNode("", true), __props.hasAttachedProducts ? (_openBlock(), _createElementBlock("li", _hoisted_22, [_createElementVNode("a", {
                    onClick: _cache[16] || (_cache[16] = function ($event) {
                      fillMeta('manufacturers-productstock');
                      validateTemplate.value = false;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "Product stock")])) : _createCommentVNode("", true), _createElementVNode("li", null, [_createElementVNode("a", {
                    onClick: _cache[17] || (_cache[17] = function ($event) {
                      fillMeta('manufacturers-shippingcosts');
                      validateTemplate.value = false;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "Shipping costs")]), _createElementVNode("li", null, [_createElementVNode("a", {
                    onClick: _cache[18] || (_cache[18] = function ($event) {
                      fillMeta('manufacturers-ebayamazon');
                      validateTemplate.value = true;
                    }),
                    "class": "p-2 d-block text-decoration-none sh-text-dark-blue",
                    role: "button"
                  }, "Selling on eBay/Amazon")])])])];
                }, undefined, true),
                _: 1
              })];
            }, undefined, true),
            _: 1
          })];
        }, undefined, true),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), isMobileRef.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_23, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_24, _cache[49] || (_cache[49] = [_createElementVNode("span", {
        "class": "badge rounded-pill text-bg-primary position-absolute top-50 end-0 translate-middle-y font-weight-regular"
      }, "Message templates", -1)]))), [[_directive_b_modal, void 0, void 0, {
        messageTemplate: true
      }]])]), _createVNode(_component_BModal, {
        id: "messageTemplate",
        modalClass: "drawer-bottom-mobile modal-select",
        noHeader: "",
        noFooter: "",
        dialogClass: "modal-fullscreen",
        bodyClass: "p-4",
        onShown: _cache[40] || (_cache[40] = function ($event) {
          return _ctx.$emit('dropdownShown');
        }),
        lazy: ""
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", {
            "class": _normalizeClass(["position-relative collapse toggle-menu", {
              show: showMainMenu.value
            }])
          }, [_cache[53] || (_cache[53] = _createElementVNode("h5", {
            "class": "font-size-18 mb-1 sh-text-dark-blue"
          }, "Message templates", -1)), _createElementVNode("ul", _hoisted_27, [props.types.includes('Dropshippers') ? (_openBlock(), _createElementBlock("li", _hoisted_28, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_29, _cache[50] || (_cache[50] = [_createTextVNode("Dropshipping")]))), [[_directive_b_toggle, void 0, void 0, {
            "dropship-menu-mobile": true
          }]])])) : _createCommentVNode("", true), props.types.includes('Wholesalers') || props.types.includes('Liquidators') ? (_openBlock(), _createElementBlock("li", _hoisted_30, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_31, _cache[51] || (_cache[51] = [_createTextVNode("Wholesale")]))), [[_directive_b_toggle, void 0, void 0, {
            "wholesale-menu-mobile": true
          }]])])) : _createCommentVNode("", true), props.types.includes('Manufacturers') ? (_openBlock(), _createElementBlock("li", _hoisted_32, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_33, _cache[52] || (_cache[52] = [_createTextVNode("Manufacturers")]))), [[_directive_b_toggle, void 0, void 0, {
            "manufacturer-menu-mobile": true
          }]])])) : _createCommentVNode("", true)])], 2), _createVNode(_component_BCollapse, {
            "class": "position-relative",
            id: "dropship-menu-mobile",
            onShow: onSubMenuShow,
            onHide: onSubMenuHide
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", _hoisted_34, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_35, _cache[54] || (_cache[54] = [_createElementVNode("h5", {
                "class": "font-size-18 mb-1 sh-text-dark-blue"
              }, "Dropshipping", -1)]))), [[_directive_b_toggle, void 0, void 0, {
                "dropship-menu-mobile": true
              }]]), _createElementVNode("ul", _hoisted_36, [_createElementVNode("li", _hoisted_37, [_cache[55] || (_cache[55] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "General inquiry", -1)), _createElementVNode("a", {
                onClick: _cache[21] || (_cache[21] = function ($event) {
                  fillMeta('dropshipper-generalenquiry');
                  validateTemplate.value = true;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")]), _createElementVNode("li", _hoisted_38, [_cache[56] || (_cache[56] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "Best selling products", -1)), _createElementVNode("a", {
                onClick: _cache[22] || (_cache[22] = function ($event) {
                  fillMeta('dropshipper-bestselling');
                  validateTemplate.value = true;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")]), __props.hasAttachedProducts ? (_openBlock(), _createElementBlock("li", _hoisted_39, [_cache[57] || (_cache[57] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "Pricing request", -1)), _createElementVNode("a", {
                onClick: _cache[23] || (_cache[23] = function ($event) {
                  fillMeta('dropshipper-pricerequest');
                  validateTemplate.value = false;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")])) : _createCommentVNode("", true), __props.hasAttachedProducts ? (_openBlock(), _createElementBlock("li", _hoisted_40, [_cache[58] || (_cache[58] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "Product stock", -1)), _createElementVNode("a", {
                onClick: _cache[24] || (_cache[24] = function ($event) {
                  fillMeta('dropshipper-productstock');
                  validateTemplate.value = false;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")])) : _createCommentVNode("", true), _createElementVNode("li", _hoisted_41, [_cache[59] || (_cache[59] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "Shipping costs and times", -1)), _createElementVNode("a", {
                onClick: _cache[25] || (_cache[25] = function ($event) {
                  fillMeta('dropshipper-shippercosts');
                  validateTemplate.value = false;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")]), _createElementVNode("li", _hoisted_42, [_cache[60] || (_cache[60] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "Dropshipping on eBay/Amazon", -1)), _createElementVNode("a", {
                onClick: _cache[26] || (_cache[26] = function ($event) {
                  fillMeta('dropshipper-ebayamazon');
                  validateTemplate.value = true;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")])])])];
            }, undefined, true),
            _: 1
          }), _createVNode(_component_BCollapse, {
            "class": "position-relative",
            id: "wholesale-menu-mobile",
            onShow: onSubMenuShow,
            onHide: onSubMenuHide
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", _hoisted_43, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_44, _cache[61] || (_cache[61] = [_createTextVNode("Wholesale")]))), [[_directive_b_toggle, void 0, void 0, {
                "wholesale-menu-mobile": true
              }]]), _createElementVNode("ul", _hoisted_45, [_createElementVNode("li", _hoisted_46, [_cache[62] || (_cache[62] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "General inquiry", -1)), _createElementVNode("a", {
                onClick: _cache[27] || (_cache[27] = function ($event) {
                  fillMeta('wholesalers-generalinquiry');
                  validateTemplate.value = true;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")]), _createElementVNode("li", _hoisted_47, [_cache[63] || (_cache[63] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "Best selling products", -1)), _createElementVNode("a", {
                onClick: _cache[28] || (_cache[28] = function ($event) {
                  fillMeta('wholesalers-bestproducts');
                  validateTemplate.value = true;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")]), __props.hasAttachedProducts ? (_openBlock(), _createElementBlock("li", _hoisted_48, [_cache[64] || (_cache[64] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "Pricing request", -1)), _createElementVNode("a", {
                onClick: _cache[29] || (_cache[29] = function ($event) {
                  fillMeta('wholesalers-pricerequest');
                  validateTemplate.value = false;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")])) : _createCommentVNode("", true), __props.hasAttachedProducts ? (_openBlock(), _createElementBlock("li", _hoisted_49, [_cache[65] || (_cache[65] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "Product stock", -1)), _createElementVNode("a", {
                onClick: _cache[30] || (_cache[30] = function ($event) {
                  fillMeta('wholesalers-productstock');
                  validateTemplate.value = false;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")])) : _createCommentVNode("", true), _createElementVNode("li", _hoisted_50, [_cache[66] || (_cache[66] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "Shipping costs", -1)), _createElementVNode("a", {
                onClick: _cache[31] || (_cache[31] = function ($event) {
                  fillMeta('wholesalers-shippingcosts');
                  validateTemplate.value = false;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")]), _createElementVNode("li", _hoisted_51, [_cache[67] || (_cache[67] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "Selling on eBay/Amazon", -1)), _createElementVNode("a", {
                onClick: _cache[32] || (_cache[32] = function ($event) {
                  fillMeta('wholesalers-ebayamazon');
                  validateTemplate.value = true;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")])])])];
            }, undefined, true),
            _: 1
          }), _createVNode(_component_BCollapse, {
            "class": "collapse position-relative",
            id: "manufacturer-menu-mobile",
            onShow: onSubMenuShow,
            onHide: onSubMenuHide
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", _hoisted_52, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_53, _cache[68] || (_cache[68] = [_createTextVNode("Manufacturers")]))), [[_directive_b_toggle, void 0, void 0, {
                "manufacturer-menu-mobile": true
              }]]), _createElementVNode("ul", _hoisted_54, [_createElementVNode("li", _hoisted_55, [_cache[69] || (_cache[69] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "Lead Times", -1)), _createElementVNode("a", {
                onClick: _cache[33] || (_cache[33] = function ($event) {
                  fillMeta('manufacturers-leadtimes');
                  validateTemplate.value = true;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")]), _createElementVNode("li", _hoisted_56, [_cache[70] || (_cache[70] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "General inquiry", -1)), _createElementVNode("a", {
                onClick: _cache[34] || (_cache[34] = function ($event) {
                  fillMeta('manufacturers-generalinquiry');
                  validateTemplate.value = true;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")]), _createElementVNode("li", _hoisted_57, [_cache[71] || (_cache[71] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "Best selling products", -1)), _createElementVNode("a", {
                onClick: _cache[35] || (_cache[35] = function ($event) {
                  fillMeta('manufacturers-bestproducts');
                  validateTemplate.value = true;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")]), __props.hasAttachedProducts ? (_openBlock(), _createElementBlock("li", _hoisted_58, [_cache[72] || (_cache[72] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "Pricing request", -1)), _createElementVNode("a", {
                onClick: _cache[36] || (_cache[36] = function ($event) {
                  fillMeta('manufacturers-pricerequest');
                  validateTemplate.value = false;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")])) : _createCommentVNode("", true), __props.hasAttachedProducts ? (_openBlock(), _createElementBlock("li", _hoisted_59, [_cache[73] || (_cache[73] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "Product stock", -1)), _createElementVNode("a", {
                onClick: _cache[37] || (_cache[37] = function ($event) {
                  fillMeta('manufacturers-productstock');
                  validateTemplate.value = false;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")])) : _createCommentVNode("", true), _createElementVNode("li", _hoisted_60, [_cache[74] || (_cache[74] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "Shipping costs", -1)), _createElementVNode("a", {
                onClick: _cache[38] || (_cache[38] = function ($event) {
                  fillMeta('manufacturers-shippingcosts');
                  validateTemplate.value = false;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")]), _createElementVNode("li", _hoisted_61, [_cache[75] || (_cache[75] = _createElementVNode("span", {
                "class": "py-2 d-block sh-text-dark-blue mt-1"
              }, "Selling on eBay/Amazon", -1)), _createElementVNode("a", {
                onClick: _cache[39] || (_cache[39] = function ($event) {
                  fillMeta('manufacturers-ebayamazon');
                  validateTemplate.value = true;
                }),
                "class": "font-size-12 font-weight-semibold text-decoration-none"
              }, "Use template")])])])];
            }, undefined, true),
            _: 1
          })])])];
        }, undefined, true),
        _: 1
      })], 64)) : _createCommentVNode("", true)], 64);
    };
  }
};